import { useContext } from "react";
import { ProductConfigurationContext } from "../providers/ProductConfigurationProvider";

const useProductConfiguration = () => {
  const context = useContext(ProductConfigurationContext);

  if (!context) {
    throw new Error(
      "useProductConfiguration must be used within a ProductConfigurationProvider"
    );
  }

  return context;
};

export default useProductConfiguration;
